import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from 'connections/restApi';

export const getMonthly = createAsyncThunk(
    'pressCycleReport/getMonthly',
    async payload => {
        const response = await api.getPressCycleMonthlyReport(payload);

        var series = [];
        for (var i = 0; i < response.length; i++) {
            var name = response[i].Machine;
            var data = response[i].Data;

            series.push({ name: name, type: 'line', data: data });
        }

        return series;
    }
)

export const getYearly = createAsyncThunk(
    'pressCycleReport/getYearly',
    async payload => {
        const response = await api.getPressCycleYearlyReport(payload);

        var series = [];
        for (var i = 0; i < response.length; i++) {
            var name = response[i].Machine;
            var data = response[i].Data;
            var years = response[i].Years;

            series.push({ name: name, data: data, years: years });
        }

        return series;
    }
)

export const getQuarterly = createAsyncThunk(
    'pressCycleReport/getQuarterly',
    async payload => {
        const response = await api.getPressCycleQuarterlyReport(payload);

        var series = [];
        for (var i = 0; i < response.length; i++) {
            var name = response[i].Machines;
            var data = response[i].Data;
            var title = response[i].Titles;

            series.push({ name: name, type: 'column', data: data, title: title });
        }

        return series;
    }
)

export const getWeekly = createAsyncThunk(
    'pressCycleReport/getWeekly',
    async payload => {
        const response = await api.getPressCycleWeeklyReport(payload);

        var series = [];
        for (var i = 0; i < response.length; i++) {
            var name = response[i].Machine;
            var data = response[i].Data;
            var title = response[i].Titles;
            var week = response[i].Weeks;

            series.push({ name: name, type: 'line', data: data, week: week, title: title });
        }

        return series;
    }
)

export const getDaily = createAsyncThunk(
    'pressCycleReport/getDaily',
    async payload => {
        const response = await api.getPressCycleDailyReport(payload);

        var series = [];
        for (var i = 0; i < response.length; i++) {
            var name = response[i].Machine;
            var data = response[i].Data;
            var titles  = response[i].Titles;

            series.push({ name: name, type: 'line', data: data, titles: titles });
        }

        return series;
    }
)